export function aclAssigneeToOption(assignee) {
    return {
        value: assignee.id,
        label: assignee.name,
        assignee,
    };
}
